import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { PatientForm } from './pages/Admin/PatientForm';
import { PatientList } from './pages/Admin/PatientList';
import { PatientDetails } from './pages/Admin/PatientDetails';
import { QuestionnaireAnalytics } from './pages/Admin/QuestionnaireAnalytics';
import { PatientQuestionnaire } from './pages/Questionnaire/PatientQuestionnaire';
import TokenQuestionnaire from './pages/Questionnaire/TokenQuestionnaire';
import { QuestionnaireComplete } from './pages/Questionnaire/QuestionnaireComplete';
import PatientRegistration from './pages/PatientRegistration/PatientRegistration';
import { RegistrationComplete } from './pages/PatientRegistration/RegistrationComplete';
import ErrorPage from './pages/ErrorPage';
import { ProtectedRoute, Start } from './pages/Start';
import DomPurifyTest from './pages/test';
import LoginPage from './pages/Login/Login';
import LogoutHeader from "./components/layout/LogoutHeader"
// (Later you'll import PatientDetail, etc.)

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Login page without container wrapper */}
        <Route path="/login" element={<LoginPage />} />
        
        {/* All other routes with container wrapper */}
        <Route
          path="/"
          element={
            <div className="start-page-container">
              <ProtectedRoute>
                <LogoutHeader>
                  <Start />
                </LogoutHeader>
              </ProtectedRoute>
            </div>
          }
        />

        <Route
          path="/admin/patients/new"
          element={
            <div className="patient-form-page-container">
              <ProtectedRoute>
                <LogoutHeader>
                  <PatientForm />
                </LogoutHeader>
              </ProtectedRoute>
            </div>
          }
        />

        <Route
          path="/admin/patients"
          element={
            <div className="patient-list-page-container">
              <ProtectedRoute>
                <LogoutHeader>
                  <PatientList />
                </LogoutHeader>
              </ProtectedRoute>
            </div>
          }
        />

        <Route
          path="/admin/patients/view/:id"
          element={
            <div className="patient-details-page-container">
              <ProtectedRoute>
                <LogoutHeader>
                  <PatientDetails />
                </LogoutHeader>
              </ProtectedRoute>
            </div>
          }
        />

        <Route
          path="/admin/patients/edit/:id"
          element={
            <div className="patient-form-page-container">
              <ProtectedRoute>
                <LogoutHeader>
                  <PatientForm />
                </LogoutHeader>
              </ProtectedRoute>
            </div>
          }
        />

        <Route
          path="/admin/analytics"
          element={
            <div className="analytics-page-container">
              <ProtectedRoute>
                <LogoutHeader>
                  <QuestionnaireAnalytics />
                </LogoutHeader>
              </ProtectedRoute>
            </div>
          }
        />

        <Route
          path="/questionnaire/:displayToken"
          element={<TokenQuestionnaire />}
        />

        <Route
          path="/questionnaire/:questionnaireId/:patientId"
          element={<PatientQuestionnaire />}
        />

        <Route
          path="/patient-registration/:registrationToken"
          element={<PatientRegistration />}
        />

        <Route
          path="/registration-complete"
          element={<RegistrationComplete />}
        />

        <Route
          path="/questionnaire-complete"
          element={<QuestionnaireComplete />}
        />

        <Route
          path="/error"
          element={<ErrorPage />}
        />

        <Route
          path="/test"
          element={
            <div className="container my-5">
              <DomPurifyTest />
            </div>
          }
        />

        {/* Show error page for unknown paths */}
        <Route path="*" element={<ErrorPage errorType="invalid_link" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;